<template><div><h1 id="ereignisauswertung-nach-merkmalen" tabindex="-1"><a class="header-anchor" href="#ereignisauswertung-nach-merkmalen"><span>Ereignisauswertung nach Merkmalen</span></a></h1>
<p>Ereignisauswertung nach Merkmalen — Ereignisdaten werden hierarchisch, nach Merkmalen gruppiert, angezeigt</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Ereignisauswertung nach Merkmalen basiert auf <RouteLink to="/referenz/refs/ft.refdata.zusatzfeldereig.html" title="Merkmale (Ereignis)">Merkmalen</RouteLink>, die bei Ereignissen oder Ereignispositionen hinterlegt sind. Die Resultatwerte werden nach den Merkmalen gruppiert und in einer frei definierbaren Hierarchie angezeigt. Wenn die Auswertung ohne Zeitraum erfasst wird, erfolgt Anzeige &quot;online&quot;, d, h. es wird immer die aktuelle Situaton angezeigt. Für eine Auswertung mit &quot;Resultate nach Zeitraum&quot;, muss ein Job gestartet werden, der die Resultate berechnet.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Ereignisauswertung nach Merkmalen</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Frame &quot;Ereignisauswertung nach Merkmalen&quot;</dt>
<dd>In diesem Frame wird die Auswertung eröffnet. Für Details siehe <a class="link" href="ft.refdata.EreigAuswAttributKopf.html" title="Ereignisauswertung nach Attributen: Kopf">Ereignisauswertung nach Merkmalen: Kopf</a>.</dd>
<dt>Job &quot;Ereignisauswertung nach Merkmalen drucken&quot;</dt>
<dd>Mit diesem job wird die Auswertung gedruckt. Er wird im Kontextmenü von <a class="link" href="ft.refproc.EreigAuswAttributDrucken.html" title="Ereignisauswertung nach Attributen drucken">Ereignisauswertung nach Merkmalen</a> gestartet. Für Details siehe <a class="link" href="ft.refproc.EreigAuswAttributDrucken.html" title="Ereignisauswertung nach Attributen drucken">Ereignisauswertung nach Merkmalen drucken</a>.</dd>
<dt>Frame &quot;Merkmalehierarchie&quot;</dt>
<dd>In diesem Frame werden die auszuwertenden Merkmale und die Anzeige-Hierarchie definiert. Siehe <a class="link" href="ft.refdata.EreigAuswAttributHierarchie.html" title="Ereignisauswertung nach Attributen: Hierarchie">Ereignisauswertung nach Merkmalen: Merkmalehierarchie</a></dd>
<dt>Frame &quot;Resultate&quot;</dt>
<dd>In diesem Frame werden die Resultate, ohne Einschränkung der Auswerteperiode, online angezeigt. Siehe <a class="link" href="ft.refdata.EreigAuswAttributResultate.html" title="Ereignisauswertung nach Attributen: Resultate">Ereignisauswertung nach Merkmalen: Resultate</a></dd>
<dt>Frame &quot;Resultate nach Zeitraum&quot;</dt>
<dd>In diesem Frame werden Auswerteperioden festgelegt. Siehe <a class="link" href="ft.refdata.EreigAuswAttributResultateZeit.html" title="Ereignisauswertung nach Attributen: Resultate nach Zeitraum">Ereignisauswertung nach Merkmalen: Resultate nach Zeitraum</a>. Damit die Resultate angezeigt werden können, muss zuerst ein Aufbereitungsjob gestartet werden.</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Optional können die Resultate mit oder ohne Ereignispositionen gedruckt werden. Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Hierarchie</td>
<td>Anzeige des Hierarchie-Baumes</td>
</tr>
<tr>
<td>Initial Anzahl</td>
<td>Anzahl Initial-Ereignisse</td>
</tr>
<tr>
<td>Refusé Anzahl</td>
<td>Anzahl der Refusé-Ereignisse</td>
</tr>
<tr>
<td>Response Anzahl</td>
<td>Anzahl der Response-Ereignisse</td>
</tr>
<tr>
<td>Response %</td>
<td>Response in %, bezogen auf die Anzahl der Response-Ereignisse</td>
</tr>
<tr>
<td>Response CHF</td>
<td>Response-Betrag</td>
</tr>
<tr>
<td>- Kosten CHF</td>
<td>Ereigniskosten</td>
</tr>
<tr>
<td>Ergebnis CHF</td>
<td>[Response CHF] - [Ereigniskosten]</td>
</tr>
</tbody>
</table>
</div></template>


